import gql from 'graphql-tag';

export default gql`
  mutation userInvite($email: String) {
    userInvite(email: $email) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
